import useGet from 'lib/hooks/useGet';
import { STATS_UPB_MATCH_SUMMARY } from 'lib/networking/endpoints';

/**
 * useUpbMatchSummary — fetches distributor-partner counts per UPB match-rate band.
 *
 * Returns { data, loading, error, refetch }
 * data shape: { total, bands: [{ band, label, name, count, share }] }
 */
function useUpbMatchSummary({ influencedOnly = false } = {}) {
  return useGet(STATS_UPB_MATCH_SUMMARY, { influenced_only: influencedOnly }, false);
}

export default useUpbMatchSummary;
